export interface ParsedSourceBrief {
  posts: string
  themes: string
  keyInsights: string[]
  tone: string | null
  audience: string | null
  uniqueAngles: string[]
  contentHooks: string[]
  quotables: string[]
  avoid: string | null
}

/**
 * Parses the JSON analysis returned by the Langsmith source_material_analysis
 * prompt into a typed object for display.
 * Returns null if the string is not valid JSON or lacks the expected shape.
 */
export const parseSourceBrief = (json: string): ParsedSourceBrief | null => {
  try {
    const parsed = JSON.parse(json)
    if (!parsed || typeof parsed !== 'object') return null

    return {
      posts: parsed.posts ?? null,
      themes: parsed.themes ?? null,
      keyInsights: Array.isArray(parsed.key_insights) ? parsed.key_insights : [],
      tone: parsed.tone ?? null,
      audience: parsed.audience ?? null,
      uniqueAngles: Array.isArray(parsed.unique_angles) ? parsed.unique_angles : [],
      contentHooks: Array.isArray(parsed.content_hooks) ? parsed.content_hooks : [],
      quotables: Array.isArray(parsed.quotables) ? parsed.quotables : [],
      avoid: parsed.avoid ?? null,
    }
  } catch {
    return null
  }
}
